import ContentData from './ContentData';

const ContentDataDefault: any = {
	"_id": "",
	"title": "",
	"content_Id": "",
	"contentId": "",
	"contentReviewer": {
		"_id": "",
		"email": "",
		"fullName": "",
		"id": ""
	},
	"tags": [],
	"authors": [
		{
			"_id": "",
			"email": "",
			"fullName": "",
			"id": ""
		}
	],
	"shared": [
		{
			"_id": "",
			"email": "",
			"fullName": "",
			"id": ""
		}
	],
	"subjects": [
		{
			"subjectId": {
				"_id": "",
				"name": ""
			},
			"_id": "",
			"chapters": [
				{
					"chapterId": {
						"_id": "",
						"name": ""
					},
					"_id": "",
					"concepts": [
						{
							"conceptId": {
								"_id": "",
								"name": ""
							},
							"conceptCode": "",
							"_id": ""
						}
					]
				}
			],
			"subSubjects": [{
				"subSubjectId": {
					"_id": "",
					"name": "",
				},
				"_id": "",
				"chapters": [{
					"chapterId": {
						"_id": "",
						"name": "",
					},
					"_id": "",
					"concepts": [{
						"conceptId": {
							"_id": "",
							"name": "",
						},
						"_id": "",
						"conceptCode": "",
						"classId": {
							"_id": "",
							"name": "",
						}
					}]
				}]
			}]
		}
	],
	"favourites": [],
	"completionPercent": 0,
	"aclMetaData": {
		"clientId": "",
		"subjects": [],
		"createdBy": {
			"id": {
				"_id": "",
				"email": "",
				"fullName": "",
				"id": ""
			},
			"email": ""
		},
		"updatedBy": {
			"id": {
				"_id": "",
				"email": "",
				"fullName": "",
				"id": ""
			},
			"email": ""
		},
		"allowedTo": [],
		"centers": []
	},
	"status": "",
	"contentSubTypeCode": "",
	"contentTypeCode": "",
	"createdAt": "",
	"updatedAt": "",
	"content": {}
}

export default ContentDataDefault;